@if (complaint(); as item) {
  <section class="mod-page" data-module="complaints">
    <header class="page-header">
      <div>
        <p class="eyebrow">{{ item.trackingId }}</p>
        <h1>
          @for (seg of hl(item.subject); track $index) {
            <span [class.hit]="seg.hit">{{ seg.text }}</span>
          }
        </h1>
        <p class="lede">
          Filed by
          @for (seg of hl(item.complainantName || item.citizenName); track $index) {
            <span [class.hit]="seg.hit">{{ seg.text }}</span>
          }
          · {{ item.district || '—' }} · {{ item.category }}
          @if (!isDm()) {
            <span [class]="'pill status-' + statusTone(item.status)">{{ item.status }}</span>
          }
        </p>
      </div>
      <div class="btn-row">
        <button type="button" class="btn primary ask-btn" (click)="askAboutCase()">Ask AI about this case</button>
        <a class="btn subtle" routerLink="/complaints">Back</a>
        @if (sourceScanExtractionId()) {
          <button type="button" class="btn subtle" (click)="viewSourceScan()">View original scan</button>
          <button type="button" class="btn subtle" (click)="downloadSourceScan()">Download original scan</button>
        }
        @if (canWorkflow()) {
          <a class="btn subtle" routerLink="/workflow">Workflow</a>
        }
      </div>
    </header>

    @if (message()) {
      <p class="toast">{{ message() }}</p>
    }

    <div class="detail-grid">
        <div class="detail-main">
          @if (aiDetails(); as ai) {
            @if (ai.subjectHindi || ai.summaryHindi) {
              <article class="narrative-card">
                <span class="card-tag tag-gray">Original text</span>
                @if (ai.subjectHindi) {
                  <p class="narrative-text" lang="hi">
                    <strong>विषय: </strong>
                    @for (seg of hl(ai.subjectHindi); track $index) {
                      <span [class.hit]="seg.hit">{{ seg.text }}</span>
                    }
                  </p>
                }
                @if (ai.summaryHindi) {
                  <p class="narrative-text" lang="hi">
                    @for (seg of hl(ai.summaryHindi); track $index) {
                      <span [class.hit]="seg.hit">{{ seg.text }}</span>
                    }
                  </p>
                }
              </article>
            }
          }

          <article class="narrative-card">
            <span class="card-tag tag-blue">AI English summary</span>
            <p class="narrative-text">
              @for (seg of hl(item.description); track $index) {
                <span [class.hit]="seg.hit">{{ seg.text }}</span>
              }
            </p>
          </article>

          <article class="panel docs-card">
            <div class="docs-head">
              <h2 class="quiet-heading">Documents</h2>
              <span class="muted">
                {{ attachments().length + (sourceScanBatchId() ? 1 : 0) }}
                file{{ attachments().length + (sourceScanBatchId() ? 1 : 0) === 1 ? '' : 's' }}
              </span>
            </div>
            @if (attachments().length || sourceScanBatchId()) {
              <ul class="docs-list">
                @for (file of attachments(); track file.id) {
                  <li>
                    <button type="button" class="doc-row" (click)="openAttachment(file)">
                      <span class="doc-kind">{{ file.kind }}</span>
                      <span class="doc-name">{{ file.fileName }}</span>
                      <span class="doc-action">Open</span>
                    </button>
                  </li>
                }
                @if (sourceScanExtractionId()) {
                  <li>
                    <div class="doc-row doc-row-split">
                      <span class="doc-kind">Source</span>
                      <span class="doc-name">Original uploaded scan</span>
                      <span class="doc-row-actions">
                        <button type="button" class="doc-action" (click)="viewSourceScan()">View</button>
                        <button type="button" class="doc-action" (click)="downloadSourceScan()">Download</button>
                      </span>
                    </div>
                  </li>
                }
              </ul>
            } @else {
              <p class="muted empty-docs">No documents uploaded for this case yet.</p>
            }
          </article>

          @if (!isDm()) {
            <article class="panel timeline-panel">
              <div class="timeline-heading">
                <h2 class="quiet-heading">
                  {{ (item.timelineCycle || 1) > 1 ? 'Current timeline' : 'Timeline' }}
                </h2>
                @if ((item.timelineCycle || 1) > 1) {
                  <span class="cycle-badge">Cycle {{ item.timelineCycle }}</span>
                }
              </div>
              @if (item.timeline.length) {
                <ul class="timeline-v2">
                  @for (event of item.timeline; track event.at + event.action) {
                    <li>
                      <span class="tl-icon" aria-hidden="true">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 13l4 4L19 7" /></svg>
                      </span>
                      <div class="tl-body">
                        <strong>{{ event.action }}</strong>
                        <p class="muted">{{ event.actor }} · {{ event.at | date: 'd MMM y, HH:mm' }}</p>
                        @if (event.note) {
                          <p>{{ event.note }}</p>
                        }
                      </div>
                    </li>
                  }
                </ul>
              } @else {
                <p class="muted">No activity recorded yet.</p>
              }

              @if (item.timelineHistory?.length) {
                <div class="timeline-history">
                  <h3>Previous timeline history</h3>
                  @for (cycle of item.timelineHistory; track cycle.cycle) {
                    <details class="history-cycle">
                      <summary>
                        <span>Cycle {{ cycle.cycle }}</span>
                        <small>
                          {{ cycle.startedAt | date: 'd MMM y' }}–{{ cycle.endedAt | date: 'd MMM y' }}
                        </small>
                      </summary>
                      <ul class="timeline-v2 history-events">
                        @for (event of cycle.timeline; track event.at + event.action) {
                          <li>
                            <span class="tl-icon" aria-hidden="true">
                              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 13l4 4L19 7" /></svg>
                            </span>
                            <div class="tl-body">
                              <strong>{{ event.action }}</strong>
                              <p class="muted">{{ event.actor }} · {{ event.at | date: 'd MMM y, HH:mm' }}</p>
                              @if (event.note) {
                                <p>{{ event.note }}</p>
                              }
                            </div>
                          </li>
                        }
                      </ul>
                    </details>
                  }
                </div>
              }
            </article>
          }
        </div>

        <aside class="detail-side">
          @if (aiDetails(); as ai) {
            <article class="panel side-card">
              <h2 class="quiet-heading">Applicant details</h2>
              <dl class="field-list-v">
                @if (ai.relativeName) {
                  <div>
                    <dt>Father's / Husband's name</dt>
                    <dd>
                      @for (seg of hl(ai.relativeName); track $index) {
                        <span [class.hit]="seg.hit">{{ seg.text }}</span>
                      }
                    </dd>
                  </div>
                }
                @if (ai.mobile) {
                  <div>
                    <dt>Mobile</dt>
                    <dd>
                      @for (seg of hl(ai.mobile); track $index) {
                        <span [class.hit]="seg.hit">{{ seg.text }}</span>
                      }
                    </dd>
                  </div>
                }
                @if (ai.location) {
                  <div>
                    <dt>Location</dt>
                    <dd>
                      @for (seg of hl(ai.location); track $index) {
                        <span [class.hit]="seg.hit">{{ seg.text }}</span>
                      }
                    </dd>
                  </div>
                }
                @if (ai.thana) {
                  <div>
                    <dt>Thana</dt>
                    <dd>
                      @for (seg of hl(ai.thana); track $index) {
                        <span [class.hit]="seg.hit">{{ seg.text }}</span>
                      }
                    </dd>
                  </div>
                }
                @if (ai.araziKhasraNo) {
                  <div>
                    <dt>Arazi / Khasra No.</dt>
                    <dd>
                      @for (seg of hl(ai.araziKhasraNo); track $index) {
                        <span [class.hit]="seg.hit">{{ seg.text }}</span>
                      }
                    </dd>
                  </div>
                }
                @if (ai.forwardedTo) {
                  <div>
                    <dt>Forwarded to</dt>
                    <dd>
                      @for (seg of hl(ai.forwardedTo); track $index) {
                        <span [class.hit]="seg.hit">{{ seg.text }}</span>
                      }
                    </dd>
                  </div>
                }
              </dl>
            </article>
          }

          <article class="panel side-card">
            <h2 class="quiet-heading">{{ isDm() ? 'Case specification' : 'Case status' }}</h2>
            <dl class="field-list-v">
              @if (isDm()) {
                <div>
                  <dt>Case ID</dt>
                  <dd>{{ item.trackingId || item.id }}</dd>
                </div>
                <div>
                  <dt>Filed by</dt>
                  <dd>
                    @for (seg of hl(item.complainantName || item.citizenName || '—'); track $index) {
                      <span [class.hit]="seg.hit">{{ seg.text }}</span>
                    }
                  </dd>
                </div>
                <div [class.unset]="!item.department || item.department === '—'">
                  <dt>Department</dt>
                  <dd>{{ item.department || 'Not set' }}</dd>
                </div>
                <div>
                  <dt>Case type</dt>
                  <dd>{{ item.category || '—' }}</dd>
                </div>
                <div>
                  <dt>District</dt>
                  <dd>{{ item.district || '—' }}</dd>
                </div>
                <div>
                  <dt>Subject</dt>
                  <dd>
                    @for (seg of hl(item.subject || '—'); track $index) {
                      <span [class.hit]="seg.hit">{{ seg.text }}</span>
                    }
                  </dd>
                </div>
              } @else {
                <div><dt>Status</dt><dd><span [class]="'pill status-' + statusTone(item.status)">{{ item.status }}</span></dd></div>
                <div><dt>Priority</dt><dd>{{ item.priority }}</dd></div>
                <div [class.unset]="!item.department || item.department === '—'">
                  <dt>Department</dt><dd>{{ item.department || 'Not set' }}</dd>
                </div>
                <div [class.unset]="!item.assignedOfficerRef && !item.assignedRole">
                  <dt>Assigned officer</dt><dd>{{ item.assignedOfficerRef || item.assignedRole || 'Unassigned' }}</dd>
                </div>
              }
            </dl>
          </article>
        </aside>
    </div>

    @if (previewOpen()) {
      <div class="preview-backdrop" (click)="closePreview()">
        <div class="preview-modal" (click)="$event.stopPropagation()">
          <div class="preview-modal-head">
            <h2>Original uploaded scan</h2>
            <button type="button" class="preview-close" (click)="closePreview()" aria-label="Close">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12" /></svg>
            </button>
          </div>
          <div class="preview-modal-body">
            @if (previewLoading()) {
              <div class="preview-status">Loading…</div>
            } @else if (previewKind() === 'image' && previewUrl()) {
              <img [src]="previewUrl()" alt="Uploaded scan" />
            } @else if (previewKind() === 'pdf' && previewUrl()) {
              <iframe [src]="safePreviewUrl()" title="Uploaded scan"></iframe>
            } @else if (previewKind() === 'unsupported') {
              <div class="preview-status">Preview unavailable for this file type — use download instead.</div>
            }
          </div>
        </div>
      </div>
    }
  </section>
} @else {
  <section class="mod-page" data-module="complaints">
    <div class="panel">
      <h1>Complaint not found</h1>
      <a class="btn primary" style="margin-top:.8rem;display:inline-flex" routerLink="/complaints">Return to inbox</a>
    </div>
  </section>
}
